import { Sidebar, Menu, MenuItem, useProSidebar, SubMenu } from 'react-pro-sidebar';
import { TbArrowsExchange } from 'react-icons/tb';
import Header from './Header';
import { MdSpaceDashboard, MdArticle } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { useSelector } from 'react-redux';

const SidebarNew = ({ ChildForm }) => {

  const { collapseSidebar } = useProSidebar();
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const loginreducer = useSelector((state) => state.reducers.loginreducer.loginDetails?.roleServices);
  const location = useLocation(); // Get the current path
  const parentReports = useSelector((state) => state.reducers.loginreducer.loginDetails?.showReports);

  const toggleSidebar = () => {
    collapseSidebar();
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };
  const isActive = (path) => location.pathname === path;
  return (
    <>
      <Header />
      <div style={{ display: 'flex', paddingTop: "26px" }}>
        <Sidebar defaultCollapsed={false} className='side-bar'>
          <Menu className='nav-bar-nyay'>
            <button variant="dark" className='arrows-button' onClick={() => { toggleSidebar() }} style={{ width: '100%' }} >
              <TbArrowsExchange className="arrow-icons" /></button>
            {loginreducer &&
              loginreducer?.map(service => {
                if (service.parent_id === 0) {
                  return (

                    <OverlayTrigger
                      key={service.service_id}
                      overlay={<Tooltip id={`tooltip-${service.service_id}`}>{service.service_name}</Tooltip>}
                      placement="right"
                    >
                      <SubMenu
                        label={
                          <>
                            <MdSpaceDashboard size={23} />&nbsp;
                            {service.service_name}
                          </>
                        }
                        className="menu-high-button"
                      >
                        {loginreducer
                          .filter(childService => childService.parent_id === service.service_id)
                          .map(childService => (
                            <OverlayTrigger
                              key={childService.service_id}
                              overlay={<Tooltip id={`tooltip-${childService.service_id}`}>{childService.service_name}</Tooltip>}
                              placement="right"
                            >
                              {/* <MenuItem
                                onClick={() => {
                                  const targetPath = childService.target;
                                  if (targetPath !== "#") {
                                    navigate(targetPath);
                                  }
                                }}
                                className={`menu-high-button ${isActive(`${childService.target}`) ? 'active-menu-item' : ''}`}
                              > */}
                               <MenuItem
  onClick={() => {
    const targetPath = childService.target;

    if (targetPath !== "#") {
    navigate(targetPath, {
  state: {
    endpoint: {
      showreport_list: parentReports || []
    },
    serviceID: childService.service_id
  }
});
    }
  }}
>
                                <MdArticle style={{ marginRight: '10px' }} />
                                {childService.service_name}
                              </MenuItem>
                            </OverlayTrigger>
                          ))}
                      </SubMenu>
                    </OverlayTrigger>
                  );
                }
                return null;
              })}
          </Menu>
        </Sidebar>
        <main style={{ flex: 1, marginLeft: isSidebarCollapsed ? '90px' : '250px', transition: 'margin-left 0.3s ease' }}>
          <div>
            {ChildForm}
          </div>
        </main>
      </div>
    </>
  );
}
export default SidebarNew;